import { action } from "typesafe-actions";
import { IBusinessPolicyAdditional } from "./businessPolicyAdditional.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { api } from "../../../api/api";
import { ERROR_MESSAGES } from "../../../constants/enums";

export const FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_PROGRESS =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_PROGRESS";
export const FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_SUCCESS =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_SUCCESS";
export const FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_FAILED =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_FAILED";
export const fetchBusinessPolicyAdditionalListProgress = () =>
  action(FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_PROGRESS);

export const fetchBusinessPolicyAdditionalListSuccess = (
  data: IBusinessPolicyAdditional[]
) => action(FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_SUCCESS, { data });
export const fetchBusinessPolicyAdditionalListFailed = () =>
  action(FETCH_BUSINESS_POLICY_ADDITIONAL_LIST_FAILED);

export const fetchBusinessPolicyAdditionalListAsync =
  (customerPolicyId: number, status?: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBusinessPolicyAdditionalListProgress());
      let finalUrl = `/policy/get-policy-business-additional-interest?customer_policy_id=${customerPolicyId}`;

      if (status !== undefined && status !== "-1") {
        finalUrl += `&status=${status}`;
      }
      const res = await api.get(finalUrl);
      const data: IBusinessPolicyAdditional[] = res.data.data;
      dispatch(fetchBusinessPolicyAdditionalListSuccess(data));
    } catch (err: any) {
      dispatch(fetchBusinessPolicyAdditionalListProgress());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addBusinesPolicyAdditionalAsync =
  (
    additional: IBusinessPolicyAdditional,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post(
        `/policy/edit-policy-business-additional-interest`,
        {
          ...additional,
        }
      );
      dispatch(
        showMessage({
          type: "success",
          message: "Additional Interest saved successfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
      onCallback(false);
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_BUSINESS_POLICY_ADDITIONAL_PROGRESS =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_PROGRESS";
export const FETCH_BUSINESS_POLICY_ADDITIONAL_SUCCESS =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_SUCCESS";
export const FETCH_BUSINESS_POLICY_ADDITIONAL_FAILED =
  "FETCH_BUSINESS_POLICY_ADDITIONAL_FAILED";

export const fetchBusinessPolicyAdditionalProgress = () =>
  action(FETCH_BUSINESS_POLICY_ADDITIONAL_PROGRESS);
export const fetchBusinessPolicyAdditionalSuccess = (
  data: IBusinessPolicyAdditional
) => action(FETCH_BUSINESS_POLICY_ADDITIONAL_SUCCESS, { data });
export const fetchBusinessPolicyAdditionalFailed = (errorMessage: string) =>
  action(FETCH_BUSINESS_POLICY_ADDITIONAL_FAILED, { errorMessage });

export const fetchBusinessPolicyAdditionalAsync =
  (
    customerPolicyId: number,
    additionalNumber: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBusinessPolicyAdditionalProgress());
      const res = await api.get(
        `/policy/get-policy-business-additional-interest?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${additionalNumber}`
      );
      const data: IBusinessPolicyAdditional[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchBusinessPolicyAdditionalSuccess(data[0]));
      } else {
        dispatch(
          fetchBusinessPolicyAdditionalFailed(
            "Oops! We couldn't find any records associated with your additional intrest number at the moment. Please ensure that the provided information is accurate and try again."
          )
        );
      }
    } catch (err: any) {
      dispatch(
        fetchBusinessPolicyAdditionalFailed(ERROR_MESSAGES.SERVER_ERROR)
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_BUSINES_POLICY_ADDITIONAL_STATE =
  "CLEAR_BUSINES_POLICY_ADDITIONAL_STATE";
export const CLEAR_BUSINES_POLICY_ADDITIONAL =
  "CLEAR_BUSINES_POLICY_ADDITIONAL";

export const clearBusinessPolicyAdditionalState = () =>
  action(CLEAR_BUSINES_POLICY_ADDITIONAL_STATE);

export const clearBusinessPolicyAdditional = () =>
  action(CLEAR_BUSINES_POLICY_ADDITIONAL);
